import { MenuItem, TextField } from "@mui/material";
import React, { Component } from "react";

export class SimplePasswordControl extends Component<any> {
	render() {
		return (
			<div className="input-group">
				<div className="input-group-prepend">
					<span
						className="input-group-text"
						style={this.props.styleLabel || {}}
					>
						{this.props.title}
					</span>
				</div>
				<input
					className={"form-control "}
					type="password"
					placeholder={this.props.title}
					readOnly={this.props.readOnly}
					value={this.props.value || ""}
					onChange={(e) =>
						this.props.onChange(e.target.value, this.props.name || "")
					}
					style={this.props.styleTextBox || {}}
					maxLength={this.props.lengthCharacters || ""}
				></input>
			</div>
		);
	}
}
export const formatNumber = (value: number) => {
	const number = Number(value);
	if (Number.isNaN(number)) return "";
	return number.toString();
};

export type NumericTextControlProps = {
	value: any;
	title: any;
	styleLabel: any;
	readOnly: any;
	styleTextBox: any;
	onChange: any;
	name: any;
	typeNumber: any;
};

interface SimpleSelectorControlProps {
	title?: string;
	dataSource?: any[];
	selectedValue?: any;
	onChange?: (value: any) => void;
	showColor?: boolean;
	styleList?: React.CSSProperties;
	hasChoose?: boolean;
}

export function SimpleSelectorControl({
	title,
	dataSource = [],
	selectedValue,
	onChange,
	showColor,
	styleList,
	hasChoose,
}: SimpleSelectorControlProps) {
	return (
		<TextField
			select
			label={title}
			variant="outlined"
			value={selectedValue || "DEFAULT"}
			onChange={(e) =>
				onChange && onChange(e.target.value === "DEFAULT" ? "" : e.target.value)
			}
			style={styleList}
			size="small"
		>
			{hasChoose && <MenuItem value="DEFAULT">{`Choose ${title}`}</MenuItem>}
			{dataSource.map((item: any, index: number) => (
				<MenuItem value={item.id.toString()} key={index}>
					{showColor && (
						<span
							style={{
								display: "inline-block",
								width: 12,
								height: 12,
								marginRight: 8,
								backgroundColor: item.color || "#FFFFFF",
							}}
						/>
					)}
					{item.description}
				</MenuItem>
			))}
		</TextField>
	);
}

export const MultipleSelectorControl = (props: any) => {
	const options = (props.dataSource || []).map((item: any, index: number) => (
		<option value={item[props.valueField]} key={index} className="p-1">
			{item[props.textField]}
		</option>
	));
	return (
		<div className="card">
			<div className="card-header">{props.title || ""}</div>
			<div className="card-body p-0">
				<select
					className="form-select col-md-12 p-0 mes-no-border"
					multiple
					aria-label={props.title || ""}
					value={props.value || []}
					onChange={(e) => {
						const value = Array.from(
							e.target.selectedOptions,
							(option) => option.value,
						);
						props.onChange(value);
					}}
					onDoubleClick={props.onDoubleClick || undefined}
				>
					{options}
				</select>
			</div>
		</div>
	);
};
export const CheckBoxControl = (props: any) => {
	return (
		<>
			<div className="input-group">
				<div className="input-group-prepend">
					<div className="input-group-text">
						<input
							type="checkbox"
							checked={props.value}
							onChange={(e) => {
								props.onCheck(e.target.checked);
							}}
							disabled={props.disabled}
						></input>
					</div>
				</div>
				<input
					type="text"
					className="form-control"
					aria-label={props.title}
					value={props.title}
					readOnly
					style={props.styleTextBox || []}
				></input>
			</div>
		</>
	);
};
export * from "./TreePickerControl";
export * from "./TreePickerControlV2";
